<template>
  <div class="home">
    <img alt="App Logo" src="../assets/logo.png">
    <h1>TRBC Youth Updates</h1>

    <p>Please contact <span>seme@vanlabtechnologies.com</span> for support</p>
  </div>
</template>

<script>

export default {
  name: 'home',
  components: {}
}
</script>

<style scoped>
.home {
  text-align: center;
}
</style>


